import colors from 'tailwindcss/colors';
import MarketRegionStateCluster from '@app/model/market_area/MarketRegionStateCluster';
import { MarketPaceVerdict } from '@app/model/market_insight/MarketPace';

// The colours of the pace strip: two shades of emerald for faster, gray for in line, two shades of
// violet for slower, a white cell with a gray ring for no comparison. They do not collide with the
// demand colours (blue, indigo, amber, pink, red).
export type PaceClass = 'MUCH_FASTER' | 'FASTER' | 'IN_LINE' | 'SLOWER' | 'MUCH_SLOWER' | 'NONE';

export const PACE_CLASS_OF: Record<MarketPaceVerdict, PaceClass> = {
	MUCH_FASTER: 'MUCH_FASTER',
	FASTER: 'FASTER',
	IN_LINE: 'IN_LINE',
	SLOWER: 'SLOWER',
	MUCH_SLOWER: 'MUCH_SLOWER',
	NO_COMPARISON: 'NONE',
};

// The fill of a strip cell in the Highcharts chart (Tailwind values, not hex literals).
export const PACE_CELL_COLOR: Record<PaceClass, string> = {
	MUCH_FASTER: colors.emerald[600],
	FASTER: colors.emerald[300],
	IN_LINE: colors.gray[200],
	SLOWER: colors.violet[300],
	MUCH_SLOWER: colors.violet[600],
	NONE: colors.white,
};

// The mark of a pace item in the Legend.
export const PACE_MARK_CLASS: Record<PaceClass, string> = {
	MUCH_FASTER: 'bg-emerald-600',
	FASTER: 'bg-emerald-300',
	IN_LINE: 'bg-gray-200',
	SLOWER: 'bg-violet-300',
	MUCH_SLOWER: 'bg-violet-600',
	NONE: 'bg-white ring-1 ring-inset ring-gray-300',
};

// The demand levels in the Legend, low to high. MEDIUM never occurs in the data, so it is not listed.
export const CLUSTER_ORDER: MarketRegionStateCluster[] = [
	MarketRegionStateCluster.VERY_LOW,
	MarketRegionStateCluster.LOW,
	MarketRegionStateCluster.NORMAL,
	MarketRegionStateCluster.HIGH,
	MarketRegionStateCluster.VERY_HIGH,
];

// The tone of a MonthGrid day: the soft gradient of the rates calendar and a bar in the demand colour.
export const CLUSTER_TONE: Record<MarketRegionStateCluster, string> = {
	[MarketRegionStateCluster.VERY_LOW]: 'bg-gradient-to-b from-blue-50 border-b-4 border-blue-500',
	[MarketRegionStateCluster.LOW]: 'bg-gradient-to-b from-indigo-50 border-b-4 border-indigo-500',
	[MarketRegionStateCluster.NORMAL]: 'bg-gradient-to-b from-amber-50 border-b-4 border-amber-500',
	[MarketRegionStateCluster.MEDIUM]: 'bg-gradient-to-b from-amber-50 border-b-4 border-amber-500',
	[MarketRegionStateCluster.HIGH]: 'bg-gradient-to-b from-pink-50 border-b-4 border-pink-500',
	[MarketRegionStateCluster.VERY_HIGH]: 'bg-gradient-to-b from-red-50 border-b-4 border-red-500',
};

// The tint mark of a demand level in the Legend of the calendar.
export const CLUSTER_TINT: Record<MarketRegionStateCluster, string> = {
	[MarketRegionStateCluster.VERY_LOW]: 'bg-blue-50 border-blue-500',
	[MarketRegionStateCluster.LOW]: 'bg-indigo-50 border-indigo-500',
	[MarketRegionStateCluster.NORMAL]: 'bg-amber-50 border-amber-500',
	[MarketRegionStateCluster.MEDIUM]: 'bg-amber-50 border-amber-500',
	[MarketRegionStateCluster.HIGH]: 'bg-pink-50 border-pink-500',
	[MarketRegionStateCluster.VERY_HIGH]: 'bg-red-50 border-red-500',
};
